"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = __importDefault(require("./helpers/uuid"));
var FileUpload = /** @class */ (function () {
    function FileUpload(file, fileName, fileSize, chunksCount, uploader) {
        this._chunksDoneCount = 0;
        this._id = (0, uuid_1.default)();
        this._file = file;
        this._fileName = fileName;
        this._fileSize = fileSize;
        this._chunksCount = chunksCount;
        this._uploader = uploader;
        this._isChunked = false;
    }
    Object.defineProperty(FileUpload.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "file", {
        get: function () {
            return this._file;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "fileId", {
        get: function () {
            return this._fileId;
        },
        set: function (fileId) {
            if (this._fileId === undefined) {
                this._fileId = fileId;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "fileName", {
        get: function () {
            return this._fileName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "fileSize", {
        get: function () {
            return this._fileSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "chunksCount", {
        get: function () {
            return this._chunksCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "chunksDoneCount", {
        get: function () {
            return this._chunksDoneCount;
        },
        enumerable: false,
        configurable: true
    });
    FileUpload.prototype.incrementChunksDoneCount = function () {
        this._chunksDoneCount++;
    };
    FileUpload.prototype.decrementChunksDoneCount = function () {
        this._chunksDoneCount--;
    };
    Object.defineProperty(FileUpload.prototype, "fileHash", {
        get: function () {
            return this._fileHash;
        },
        set: function (fileHash) {
            this._fileHash = fileHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "uploader", {
        get: function () {
            return this._uploader;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "isChunked", {
        get: function () {
            return this._isChunked;
        },
        set: function (isChunked) {
            this._isChunked = isChunked;
        },
        enumerable: false,
        configurable: true
    });
    return FileUpload;
}());
exports.default = FileUpload;
//# sourceMappingURL=FileUpload.js.map